/**
 * Recovery key generation + parsing (Task #84).
 *
 * A 24-word BIP-39 mnemonic (256 bits of entropy) acts as a password-equivalent
 * unlock path. Users write it down once at vault creation and store it offline.
 */

import { generateMnemonic, mnemonicToEntropy, validateMnemonic } from "@scure/bip39";
import { wordlist } from "@scure/bip39/wordlists/english.js";

export function generateRecoveryPhrase(): string {
  // 256 bits → 24 words
  return generateMnemonic(wordlist, 256);
}

export function normalizeRecoveryPhrase(raw: string): string {
  return raw.trim().toLowerCase().split(/\s+/).join(" ");
}

export function isValidRecoveryPhrase(raw: string): boolean {
  try {
    const normalized = normalizeRecoveryPhrase(raw);
    // Vault recovery phrases are always 24 words (256 bits of entropy). Reject
    // shorter valid BIP-39 phrases up front for a clearer error message.
    if (normalized.split(" ").length !== 24) return false;
    return validateMnemonic(normalized, wordlist);
  } catch {
    return false;
  }
}

export function recoveryPhraseToEntropy(raw: string): Uint8Array {
  return mnemonicToEntropy(normalizeRecoveryPhrase(raw), wordlist);
}
